import { useEffect, useId, useRef, type ReactNode } from "react";

type Props = {
  open: boolean;
  title: string;
  /** Roda uma vez a cada fechamento: botão Fechar, Esc ou open=false. */
  onClose(): void;
  children: ReactNode;
  footer?: ReactNode;
};

/**
 * <dialog> nativo: showModal() já dá a semântica modal, o foco preso e o Esc (por isso sem aria-modal fixo, FE6).
 * Nenhuma classe de layout do Bootstrap no <dialog>: .modal-content define display:flex e deixaria o diálogo visível
 * fechado (FE4). O elemento com data-autofocus recebe o foco ao abrir (FE18).
 */
export function Modal({ open, title, onClose, children, footer }: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  const id = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.hasAttribute("open")) {
      d.showModal();
      d.querySelector<HTMLElement>("[data-autofocus]")?.focus();
    }
    if (!open && d.hasAttribute("open")) d.close();
  }, [open]);
  return (
    <dialog ref={ref} className="cx-dialog" aria-labelledby={id} onClose={onClose}>
      <div className="modal-content shadow">
        <div className="modal-header">
          <h2 id={id} className="modal-title h5">
            {title}
          </h2>
          <button
            type="button"
            className="btn-close"
            aria-label="Fechar"
            onClick={() => ref.current?.close()}
          />
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </dialog>
  );
}
